import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Holder = styled.div.attrs( props => ({
  id: props.uniqueId || '',
}) )`
  max-width: ${props => props.theme.typography.maxScreen}px;
  margin: 0 auto;
  padding: 0 1rem;
  @media(${props => props.theme.breakpoints.md}) {
    padding: 0 4rem;
  }
  @media(${props => props.theme.breakpoints.md}) {
    padding: 0 6rem;
  }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
`;

function Container( {uniqueId, children} ) {

  return (
    <Holder uniqueId={uniqueId}>
      {children}
    </Holder>
  )
}

Container.propTypes = {
  uniqueId: PropTypes.string
};

export default Container;
